import {useRef, type RefObject} from 'react';

import {useOnMount} from 'shared/web';

import {useEagGridStore} from '../../store/useEagGridStore';
import {activateGridMaximization} from './utils/activateGridMaximization';

/** Only the interaction session mounts/unmounts; the grid subtree never moves. */
export function GridMaximizationSession(props: {surfaceRef: RefObject<HTMLDivElement | null>}) {
  const store = useEagGridStore();
  const cleanupRef = useRef<VoidFunction | undefined>(undefined);

  useOnMount(
    () => {
      const surface = props.surfaceRef.current;
      if (surface) {
        cleanupRef.current = activateGridMaximization(surface, () => store.setIsMaximized(false));
      }
    },
    () => {
      cleanupRef.current?.();
    }
  );

  return null;
}
